import { Power } from "lucide-react";
import Link from "next/link";
import useAuthStore from "~/stores/auth";
import DarkModeBtn from "../buttons/dark-mode";
import { Button } from "../ui/button";
import LanguageSelect from "./language-select";

const InterfaceControls = () => {
	const user = useAuthStore((state) => state.user);

	return (
		<div className="absolute top-0 flex w-full items-center justify-between gap-2 p-2">
			<div className="flex items-center gap-2" />
			<div className="flex items-center gap-2">
				<DarkModeBtn />
				<LanguageSelect />
				{user && (
					<Link href="/auth/logout">
						<Button
							className="border-destructive/60 text-destructive"
							size="icon"
							variant="outline"
						>
							<Power size="18" />
						</Button>
					</Link>
				)}
			</div>
		</div>
	);
};

export default InterfaceControls;
